import {css, cx} from "@panda/css";

import {CloseIcon} from "@pg-design/icons-module";

interface IProps {
    className?: string;
    dataTestId?: string;
    onClick: () => void;
    size?: string;
    top?: number;
    right?: number;
}

export const CloseIconButton = (props: IProps) => {
    const {top = 3, right = 3, onClick, className, size, dataTestId} = props;

    const wrapperStyles = css({
        position: "absolute",
        top: top,
        right: right,
        cursor: "pointer"
    });

    return (
        <button type="button" className={cx(wrapperStyles, className)} onClick={onClick} data-testid={dataTestId}>
            <CloseIcon size={size || "2.4"} />
        </button>
    );
};
